/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect} from 'react'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useAuth} from '../auth/core/Auth'
import {cnhSignup, ConnectAndHealSignup} from '../auth/core/_requests'
import {ConnectAndHealModel} from '../auth/core/_models'

const registrationSchema = Yup.object().shape({
  Name: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('First name is required'),
  Email: Yup.string().email().required('Email is required'),
  Password: Yup.string(),
  ContactNumber: Yup.string()
    .min(10, 'Minimum 10 numbers')
    .max(10, 'Maximum 10 numbers')
    .required('Mobile Number is required'),
  Gender: Yup.string().required('Gender Required'),
  Dob: Yup.date().required('Date of Birth Required'),
  EmployeeId: Yup.string().required('EmployeeId Required'),
  Address: Yup.string().required('Address is required'),
  Pincode: Yup.number().required('Pincode is required'),
})

export function ConnectAndHealForm() {
  const initialValues = {
    Name: useAuth().currentUser?.Name,
    Email: useAuth().currentUser?.Email,
    Password: 'futurisk',
    ContactNumber: useAuth().currentUser?.PhoneNumber,
    Gender: useAuth().currentUser?.Gender,
    Dob: useAuth().currentUser?.Dob.toString().split('T')[0],
    EmployeeId: useAuth().currentUser?.EmployeeId,
    Address: '',
    Pincode: '',
    consentToPrivacyPolicy: false,
    consentToThirdParty: false,
  }
  const [loading, setLoading] = useState(false)
  const username = useAuth().currentUser?.UserName!
  const CRMClientId = useAuth().currentUser?.CRMClientId!
  const formik = useFormik({
    initialValues,
    validationSchema: registrationSchema,
    validate: (values) => {
      const errors: any = {}
      if (!values.consentToPrivacyPolicy) {
        errors.consentToPrivacyPolicy = 'You must agree to the Privacy Policy'
      }
      if (!values.consentToThirdParty) {
        errors.consentToThirdParty = 'You must consent to third-party data forwarding'
      }
      return errors
    },
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
        let data: ConnectAndHealModel = {
          name: values.Name!,
          email: values.Email!,
          password: values.Password,
          contactNumber: values.ContactNumber!,
          address: values.Address,
          pincode: values.Pincode,
          dob: values.Dob?.toString()!,
          employeeId: values.EmployeeId!,
          CrmLoginId: username,
          gender: values.Gender!,
        }
        if (CRMClientId === 188) {
          alert(await (await cnhSignup(data)).data)
        } else {
          alert(await (await ConnectAndHealSignup(data)).data)
        }

        setLoading(false)
        window.location.reload()
        // submit data
      } catch (error) {
        console.error(error)
        setLoading(false)
      }
    },
  })

  useEffect(() => {
    //PasswordMeterComponent.bootstrap()
  }, [])

  return (
    <form
      className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
      noValidate
      id='kt_pristyncare_form'
      onSubmit={formik.handleSubmit}
    >
      {/* begin::Heading */}
      <div className='text-center'>
        {/* begin::Title */}
        <h1 className='text-dark mb-3 '> </h1>
        {/* end::Title */}
      </div>
      {/* end::Heading */}

      {formik.status && (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )}

      {/* begin::Form group EmployeeId */}
      <div className='fv-row mb-7'>
        <label className='form-label fw-bolder text-dark fs-6'>EmployeeId</label>
        <input
          placeholder='EmployeeId'
          type='text'
          autoComplete='off'
          {...formik.getFieldProps('EmployeeId')}
          className={clsx(
            'form-control  form-control-solid',
            {
              'is-invalid': formik.touched.EmployeeId && formik.errors.EmployeeId,
            },
            {
              'is-valid': formik.touched.EmployeeId && !formik.errors.EmployeeId,
            }
          )}
        />
        {formik.touched.EmployeeId && formik.errors.EmployeeId && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.EmployeeId}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}
      {/* begin::Form group Firstname */}
      <div className='fv-row mb-7'>
        <label className='form-label fw-bolder text-dark fs-6'>Name</label>
        <input
          placeholder='First name'
          type='text'
          autoComplete='off'
          {...formik.getFieldProps('Name')}
          className={clsx(
            'form-control  form-control-solid',
            {
              'is-invalid': formik.touched.Name && formik.errors.Name,
            },
            {
              'is-valid': formik.touched.Name && !formik.errors.Name,
            }
          )}
        />
        {formik.touched.Name && formik.errors.Name && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.Name}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group Email */}
      <div className='fv-row mb-7'>
        <label className='form-label fw-bolder text-dark fs-6'>Email</label>
        <input
          placeholder='Email'
          type='text'
          autoComplete='off'
          {...formik.getFieldProps('Email')}
          className={clsx(
            'form-control  form-control-solid',
            {'is-invalid': formik.touched.Email && formik.errors.Email},
            {
              'is-valid': formik.touched.Email && !formik.errors.Email,
            }
          )}
        />
        {formik.touched.Email && formik.errors.Email && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.Email}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group ContactNumber */}
      <div className='fv-row mb-7'>
        <label className='form-label fw-bolder text-dark fs-6'>Contact Number</label>
        <input
          placeholder='Contact Number'
          type='text'
          autoComplete='off'
          {...formik.getFieldProps('ContactNumber')}
          className={clsx(
            'form-control  form-control-solid',
            {
              'is-invalid': formik.touched.ContactNumber && formik.errors.ContactNumber,
            },
            {
              'is-valid': formik.touched.ContactNumber && !formik.errors.ContactNumber,
            }
          )}
        />
        {formik.touched.ContactNumber && formik.errors.ContactNumber && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.ContactNumber}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group Gender */}
      <div className='fv-row mb-7'>
        <label className='form-label fw-bolder text-dark fs-6'>Gender</label>
        <input
          placeholder='Gender'
          type='text'
          autoComplete='off'
          {...formik.getFieldProps('Gender')}
          className={clsx(
            'form-control  form-control-solid',
            {
              'is-invalid': formik.touched.Gender && formik.errors.Gender,
            },
            {
              'is-valid': formik.touched.Gender && !formik.errors.Gender,
            }
          )}
        />
        {formik.touched.Gender && formik.errors.Gender && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.Gender}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group Dob */}
      <div className='fv-row mb-7'>
        <label className='form-label fw-bolder text-dark fs-6'>Dob</label>
        <input
          placeholder='Dob'
          type='date'
          autoComplete='off'
          {...formik.getFieldProps('Dob')}
          className={clsx(
            'form-control  form-control-solid',
            {
              'is-invalid': formik.touched.Dob && formik.errors.Dob,
            },
            {
              'is-valid': formik.touched.Dob && !formik.errors.Dob,
            }
          )}
        />
        {formik.touched.Dob && formik.errors.Dob && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.Dob}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group Address */}
      <div className='fv-row mb-7'>
        <label className='form-label fw-bolder text-dark fs-6'>Address</label>
        <textarea
          placeholder='Address'
          autoComplete='off'
          {...formik.getFieldProps('Address')}
          className={clsx(
            'form-control  form-control-solid',
            {
              'is-invalid': formik.touched.Address && formik.errors.Address,
            },
            {
              'is-valid': formik.touched.Address && !formik.errors.Address,
            }
          )}
        />
        {formik.touched.Address && formik.errors.Address && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.Address}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group Pincode */}
      <div className='fv-row mb-7'>
        <label className='form-label fw-bolder text-dark fs-6'>Pincode</label>
        <input
          placeholder='Pincode'
          type='text'
          autoComplete='off'
          {...formik.getFieldProps('Pincode')}
          className={clsx(
            'form-control  form-control-solid',
            {
              'is-invalid': formik.touched.Pincode && formik.errors.Pincode,
            },
            {
              'is-valid': formik.touched.Pincode && !formik.errors.Pincode,
            }
          )}
        />
        {formik.touched.Pincode && formik.errors.Pincode && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.Pincode}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group - Privacy Policy Consent */}
      <div className='fv-row mb-5'>
        <div className='form-check form-check-custom form-check-solid'>
          <input
            className='form-check-input'
            type='checkbox'
            id='kt_login_privacy_policy_agree'
            {...formik.getFieldProps('consentToPrivacyPolicy')}
          />
          <label
            className='form-check-label fw-bold text-gray-700 fs-6'
            htmlFor='kt_login_privacy_policy_agree'
          >
            I agree to the{' '}
            <a
              href='https://futurisk.in/privacy-policy'
              target='_blank'
              rel='noopener noreferrer'
              className='link-primary'
            >
              Privacy Policy
            </a>
            .
          </label>
          {formik.touched.consentToPrivacyPolicy && formik.errors.consentToPrivacyPolicy && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.consentToPrivacyPolicy}</span>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* end::Form group */}

      {/* begin::Form group - Third Party Data Forwarding Consent */}
      <div className='fv-row mb-10'>
        <div className='form-check form-check-custom form-check-solid'>
          <input
            className='form-check-input'
            type='checkbox'
            id='kt_login_third_party_agree'
            {...formik.getFieldProps('consentToThirdParty')}
          />
          <label
            className='form-check-label fw-bold text-gray-700 fs-6'
            htmlFor='kt_login_third_party_agree'
          >
            I consent to my personal data being forwarded to third-party service providers for
            wellness services.
          </label>
          {formik.touched.consentToThirdParty && formik.errors.consentToThirdParty && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.consentToThirdParty}</span>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='text-center'>
        <button
          type='submit'
          id='kt_sign_up_submit'
          className='btn btn-lg btn-primary w-100 mb-5'
          disabled={
            formik.isSubmitting ||
            !formik.isValid ||
            !formik.values.consentToPrivacyPolicy ||
            !formik.values.consentToThirdParty
          }
        >
          {!loading && <span className='indicator-label'>Submit</span>}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...{' '}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
      {/* end::Form group */}
    </form>
  )
}
